import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { loadShoppingCart } from 'src/app/state/shopping-cart.actions';
import { AddScoreRecipientExpressShippingRequest, AddShoppingCartItemRequest, AddShoppingCartItemsForChildAccountsRequest, AddShoppingCartItemWithReg, CheckOutReviewInfoDto, PaymentProcessingRequest, PlaceOrderRequest, ResultWrapper, ShippingRequest, ShoppingCartDto, UserCheckOutShippingDto, UserOrderAddressRequest } from '../dtos/dto';
import { ConfigHelper } from './helpers/config.helper';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {

  constructor(
    private configHelper: ConfigHelper,
    private http: HttpClient,
    private store: Store
  ) { }

  getShoppingCart(): Observable<ResultWrapper<ShoppingCartDto>> {
    return this.http.get<ResultWrapper<ShoppingCartDto>>(this.configHelper.getApiUrl("User/ShoppingCart"));
  }

  addProduct(shoppingCartItemRequest: AddShoppingCartItemRequest): Observable<ResultWrapper<ShoppingCartDto>> {
    return this.http.post<ResultWrapper<ShoppingCartDto>>(this.configHelper.getApiUrl("User/ShoppingCart/ProductItems"), shoppingCartItemRequest);
  }

  removeShoppingCartItem(shoppingCartItemId: number): Observable<ResultWrapper<ShoppingCartDto>> {
    return this.http.delete<ResultWrapper<ShoppingCartDto>>(this.configHelper.getApiUrl("User/ShoppingCart/Item/") + shoppingCartItemId);
  }

  updateShoppingCartItem(shoppingCartItemId: number, quantity: number): Observable<ResultWrapper<ShoppingCartDto>> {
    return this.http.put<ResultWrapper<ShoppingCartDto>>(this.configHelper.getApiUrl("User/ShoppingCart/Item/") + shoppingCartItemId, { quantity });
  }

  batchAddItem(addShoppingCartItemsForChildAccountsRequest: AddShoppingCartItemsForChildAccountsRequest): Observable<ResultWrapper<ShoppingCartDto>> {
    return this.http.post<ResultWrapper<ShoppingCartDto>>(this.configHelper.getApiUrl("User/ShoppingCart/ProductItems/ChildBatch"), addShoppingCartItemsForChildAccountsRequest);
  }

  checkForWarnings(productId: number): Observable<ResultWrapper<string>> {
    return this.http.post<ResultWrapper<string>>(this.configHelper.getApiUrl("User/ShoppingCart/CheckForWarnings"), { productId });
  }

  setShoppingCart(result: ResultWrapper<ShoppingCartDto>) {
    this.store.dispatch(loadShoppingCart({ shoppingCart: result.content }));
  }

  addItemWithReg(request: AddShoppingCartItemWithReg): Observable<ResultWrapper<string>> {
    return this.http.post<ResultWrapper<string>>(this.configHelper.getApiUrl("User/ShoppingCart/ProductItemsWithReg"), request);
  }

  checkoutInfoOrderAddress(request: UserOrderAddressRequest): Observable<ResultWrapper<string>> {
    return this.http.put<ResultWrapper<string>>(this.configHelper.getApiUrl("User/CheckOutInfo/OrderAddress"), request);
  }

  prepareForShipping(): Observable<ResultWrapper<boolean>> {
    const request = {};
    return this.http.post<ResultWrapper<boolean>>(this.configHelper.getApiUrl("User/CheckOut/PrepareForShipping"), request);
  }

  checkoutInfoShippingGet(): Observable<ResultWrapper<UserCheckOutShippingDto>> {
    return this.http.get<ResultWrapper<UserCheckOutShippingDto>>(this.configHelper.getApiUrl("User/CheckOutInfo/Shipping"));
  }

  checkoutInfoShippingPut(request: ShippingRequest): Observable<ResultWrapper<string>> {
    return this.http.put<ResultWrapper<string>>(this.configHelper.getApiUrl("User/CheckOutInfo/Shipping"), request);
  }

  checkoutInfoFinal(): Observable<ResultWrapper<CheckOutReviewInfoDto>> {
    const request = {};
    return this.http.post<ResultWrapper<CheckOutReviewInfoDto>>(this.configHelper.getApiUrl("User/CheckOutInfo/Final"), request);
  }

  checkoutOrder(request: PlaceOrderRequest): Observable<ResultWrapper<PaymentProcessingRequest>> {
    return this.http.post<ResultWrapper<PaymentProcessingRequest>>(this.configHelper.getApiUrl("User/CheckOut/Order"), request);
  }

  addItemsWithReg(productIds: number[], regId: number) {
    const items = [];
    productIds.forEach(id => {
      const item = { RegId: regId, ProductId: id };
      items.push(item);
    });
    return this.http.post<ResultWrapper<string>>(this.configHelper.getApiUrl("User/ShoppingCart/BatchProductItemsWithReg"), items);
  }

  addExpressServiceToCart(ScoreRecipientRegIds: number[]) {
    return this.http.post(this.configHelper.getApiUrl("User/ShoppingCart/ScoreRecipientExpressShipping"), ScoreRecipientRegIds);
  }

}
